import Swiper, { Navigation } from 'swiper';
import { partnersSlider } from '../components/partnersSlider';
import { featuresContent } from '../components/featuresContent';

export default {
  init() {
    // JavaScript to be fired on the home page
    new Swiper('.home-news .swiper-container', {
      modules: [Navigation],
      direction: 'horizontal',
      loop: false,
      autoResize: false,
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        disabledClass: 'swiper-button--disabled',
      },
    }), partnersSlider(),
      featuresContent();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js